import BaseService from './BaseService'

class ModifierGroupService extends BaseService {
  constructor() {
    super('/modifier-groups')
  }

  async list({ includeModifiers = false } = {}) {
    return this.customRequest('get', '', null, {
      params: { include_modifiers: includeModifiers }
    })
  }

  async get(id) {
    return this.getById(id)
  }

  async createGroup(payload) {
    return this.create(payload)
  }

  async updateGroup(id, payload) {
    return this.update(id, payload)
  }

  async updateDefaults(id, defaults) {
    return this.customRequest('put', `/${id}/defaults`, { defaults })
  }
}

export const modifierGroupService = new ModifierGroupService()

